export const environment = {
  production: true,
  name: 'deploy',
  'apiServer': {
    'apiConsumerKey': 'fdcc0bf4d5e8ba1e9fe39b9ae404e861TRNmENtRynX2KQkc',
    'apiConsumerSecret': 'ddf2822702c88a754cc7df20d6e8bac0fc57d628d17dfc11f9ff2517ecb6ee04kXySxGAcGb5VUEeO'
  },

  auth0: {
    authUrl: 'https://theprintlife.us.auth0.com/authorize',
    clientId: 'nHzNGqpTA6mDoHGn6U0kitnDqRoxjfId',
    client_secret:'FSAOzjhpc5PXDTK8nT1XYSPfXi-rD1mNbrsKSWwpOTRQ-9l9_pB1wiZg_in9X6-4',
    redirectUri: 'https://login.theprintlife.com/login',
    getAuth0UserToken: 'https://theprintlife.us.auth0.com/oauth/token',
    getauth0UserInfo: 'https://theprintlife.us.auth0.com/userinfo',
  },

  stripe: {
    authUrl: 'https://connect.stripe.com/oauth/authorize',
    clientId: 'ca_P6dnKGkz0tRaPoJpuXRtXLwBohipOwxs',
    client_secret: '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',
    redirectUri: 'https://login.theprintlife.com/settings/api-info/paymentProcessors',
    tokenEndpoint: 'https://connect.stripe.com/oauth/token'
  },

  googleOAuth2: {
    authUrl: 'https://accounts.google.com/o/oauth2/auth',
    clientId: '342462359681-dga6mj18lvgq3t837asud17s9se00305.apps.googleusercontent.com',
    clientSecret: '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',
    redirectUri: 'https://login.theprintlife.com/settings/smtp-mail-settings',
    tokenEndpoint:'https://oauth2.googleapis.com/token'
  },

  outlookOAuth2: {
    authUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    clientId: '1a0d624b-93c8-4937-a1a0-5b991cbe4475',
    clientSecret: 'w3Q8Q~NUJ_spfAMK7IYYxkHPEwyaikcXThI5Aa9F',
    redirectUri: 'https://login.theprintlife.com/settings/smtp-mail-settings',
    tokenEndpoint:'https://login.microsoftonline.com/consumers/oauth2/v2.0/token'
  },

  squareupOAuth2: {
    authUrl: 'https://connect.squareup.com/oauth2/authorize',
    clientId: 'sq0idp-7ZHAkJT9jkR4DIIzfX61CA',
    clientSecret: 'sq0csp-WSZ0FnCP87o-ycboi2doOT4KXOCORrTY27KEaYupL8w',
    redirectUri: 'https://login.theprintlife.com/settings/api-info/paymentProcessors'
  },

  recaptcha: {
    siteKey: '6LfxSk0qAAAAABEhxII88r-CzcG50SFRhNnSRK8k'
  },

  'API_URL': 'https://loginapi.theprintlife.com',
  'Admin_URL': 'https://login.theprintlife.com/login',
  'Client_URL': 'https://login.theprintlife.com/login',
  'Public_URL': 'https://login.theprintlife.com/',
  'Store_URL': 'merchshoplive.com/store',
  'PublicQuoteBuilder_URL': 'project-builder.app',
  'Old_Client_URL': 'https://oldlogin.theprintlife.com/login',

  PAYPAL_ENV_MODE: 'production',
  SQUAREUP_URL:"https://web.squarecdn.com/v1/square.js"
};




// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/environments/environment.ts